import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'popup-limite-registros',
  templateUrl: './popup-limite-registros.component.html',
  styles: [],
})
export class PopupLimiteRegistrosComponent implements OnInit {
  cantidadRegistros: number = 0;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}

  continuar() {
    this.activeModal.close('continuar');
  }

  cancel() {
    this.activeModal.dismiss('cancelar');
  }
}
